import React from 'react';
import { Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

interface DateFieldCalendarProps {
  label: string;
  name?: string;
  value: string | null;
  onChange: (date: string | null) => void;
  isDisabled?: boolean;
  format?: string;
  isMandatory?: boolean;
}

const DateFieldCalendar: React.FC<DateFieldCalendarProps> = ({
  label,
  name,
  value,
  onChange,
  isDisabled = false,
  format = 'DD/MM/YYYY',
  isMandatory = false,
}) => {
  return (
    <div className="flex flex-col w-full">
      <Typography variant="body2" fontWeight={600} color="textPrimary">
        {label}
        {isMandatory && <span style={{ color: 'red' }}>*</span>}
      </Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          // The displayed value
          value={value ? dayjs(value, format) : null}
          // The returned value to parent
          onChange={(newValue: Dayjs | null) => onChange(newValue ? newValue.format(format) : null)}
          format={format}
          disabled={isDisabled}
          slotProps={{
            textField: { fullWidth: true, variant: 'outlined' },
          }}
          sx={(theme) => ({
            width: '100%',
            marginTop: '8px',
            '& .MuiOutlinedInput-root': {
              padding: '12px 16px',
              fontSize: '14px',
              fontWeight: 400,
              borderRadius: '8px',
              borderWidth: '1px',
              borderColor: theme.palette.action.selected,
            },
            '& .MuiInputBase-input': {
              padding: '0px',
              borderWidth: '0px',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '& .MuiSvgIcon-root': {
              color: theme.palette.primary.main,
            },
          })}
          className={`mt-2 w-full ${isDisabled ? 'bg-gray-200 cursor-not-allowed' : ''}`}
        />
      </LocalizationProvider>
    </div>
  );
};

export default DateFieldCalendar;
